import { render } from "./AdminReport.vue?vue&type=template&id=6239ff37"
import script from "./AdminReport.vue?vue&type=script&lang=js"
export * from "./AdminReport.vue?vue&type=script&lang=js"

import exportComponent from "D:\\CTS_SURAJ\\Edu Katta\\Private\\Edukatta_Private_Managment_UI\\node_modules\\vue-loader-v16\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__